import {
  Component,
  createEffect,
  createSignal,
  mergeProps,
  Show,
} from 'solid-js';
import PointCloudIntensityControl from '../point-cloud-intensity/point-cloud-intensity';
import {
  POINT_CLOUD_RGB_DEFAULTS,
  PointCloudRgbControlProps,
} from './point-cloud-rgb.model';
import { PointCloudStylingIntensityGradient } from '@trimble/types';
import { POINT_CLOUD_INTENSITY_DEFAULTS } from '../point-cloud-intensity/point-cloud-intensity.model';
import { t } from '@trimble/i18n';

export const PointCloudRgbControl: Component<PointCloudRgbControlProps> = (
  props: PointCloudRgbControlProps
) => {
  const activeProps = mergeProps(POINT_CLOUD_RGB_DEFAULTS, props);

  const [blendIntensity, setBlendIntensity] = createSignal<boolean>(false);
  const [gradient, setGradient] =
    createSignal<PointCloudStylingIntensityGradient>(
      POINT_CLOUD_INTENSITY_DEFAULTS
    );

  createEffect(() => {
    setBlendIntensity(activeProps.blendIntensity);
  });

  createEffect(() => {
    setGradient(activeProps.gradient);
  });

  const handleBlendIntensityToggle = (blendIntensity: boolean): void => {
    setBlendIntensity(blendIntensity);
    props.onChange?.({
      blendIntensity,
      gradient: gradient(),
    });
  };

  const handleGradientChange = (
    gradient: PointCloudStylingIntensityGradient
  ): void => {
    setGradient(gradient);
    props.onChange?.({
      blendIntensity: blendIntensity(),
      gradient,
    });
  };

  return (
    <div class="w-full flex flex-col gap-4">
      <div class="flex flex-row gap-2">
        <span class="flex flex-1" id="blend-intensity-label">
          {t('mobileMapping.styles.intensity.blendIntensity')}
        </span>
        <modus-wc-switch
          aria-labelledby="blend-intensity-label"
          attr:value={blendIntensity()}
          on:inputChange={(e) => {
            const checked = (e.detail.target as HTMLInputElement).checked;
            handleBlendIntensityToggle(checked);
          }}
        />
      </div>

      <Show when={blendIntensity()}>
        <PointCloudIntensityControl
          {...gradient()}
          onGradientChange={handleGradientChange}
        />
      </Show>
    </div>
  );
};

export default PointCloudRgbControl;
